<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-banned`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35 23c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zM23 2c11.176 0 20.314 8.731 20.963 19.744a15.93 15.93 0 00-4.284-2.05C38.14 11.889 31.259 6 23 6 13.611 6 6 13.611 6 23v17h13.797a15.937 15.937 0 001.973 4H4.1A2.1 2.1 0 012 41.9V23C2 11.402 11.402 2 23 2zm16.064 39.892L28.108 30.936a8 8 0 0010.956 10.956zM35 27a7.963 7.963 0 00-4.064 1.108l10.956 10.956A8 8 0 0035 27zm-16 0v4h-6v-4h6zm5-8v4H13v-4h11z"/></svg>
</template>
<script>

export default {
  name: 'IconBanned',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
